// extracted by mini-css-extract-plugin
export default {"tupacGrid":"dm-z","tupacHeader":"em-z","tupacHeader2":"fm-z","tupacMenu":"gm-z","tupacMenu2":"hm-z","tupacMain":"im-z","tupacMain2":"jm-z"};